module.exports = __webpack_public_path__ + "static/media/icon-bottom-livechat.5a7c4140.svg";